import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { useUserContext } from 'strview-common'

const LoginInterstitial = () => {
    const navigate = useNavigate()
    const { authenticateGoogleUser} = useUserContext()

    const muniLoc = localStorage.getItem('muni')
    const muniId = muniLoc ? JSON.parse(muniLoc).muniId : null
    
    console.log("muniLoc",muniLoc)
    console.log("muniId",muniId)
    const login = async () => {
        const urlParams = new URLSearchParams(window.location.search)
        const authCode = urlParams.get('code')
        // const muniId = getMuniId()
        console.log("authCode",authCode)
        const authenticationResult = await authenticateGoogleUser(authCode)
        console.log("authenticationResult",authenticationResult)
        if (authenticationResult.success) {
                console.log("navigate to welcome")
                navigate(`/${muniId}/welcome`)
        } else {
            console.log("authenticationResult.errorMessage",authenticationResult.errorMessage)
        }
    }
    useEffect(() => {
        login()
    },[]) // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <>
            <div>Login Interstitial</div>
        </>
    )
}

export default LoginInterstitial